import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight, Trash2 } from "lucide-react";

export const Route = createFileRoute("/radera-konto")({
  component: RaderaKonto,
  head: () => ({
    meta: [
      { title: "Radera konto – Alkoholprovet" },
      {
        name: "description",
        content:
          "Så begär du radering av ditt Alkoholprovet-konto och tillhörande personuppgifter.",
      },
      { property: "og:title", content: "Radera konto – Alkoholprovet" },
      {
        property: "og:description",
        content:
          "Så begär du radering av ditt Alkoholprovet-konto och tillhörande personuppgifter.",
      },
      { property: "og:url", content: "https://alkoholprovet.se/radera-konto" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/radera-konto" }],
  }),
});

function RaderaKonto() {
  return (
    <div className="container-page py-10 sm:py-16">
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-destructive/10 text-destructive">
            <Trash2 className="h-5 w-5" />
          </div>
          <h1 className="font-display text-3xl sm:text-4xl font-bold">Radera konto</h1>
        </div>

        <p className="mt-6 text-base leading-relaxed text-foreground">
          Du kan begära att ditt Alkoholprovet-konto och tillhörande personuppgifter
          raderas. Skicka din begäran via kontaktformuläret och ange den e-postadress
          som är kopplad till kontot. Vi kan behöva verifiera din identitet innan
          raderingen genomförs. Uppgifter som måste sparas enligt lag, till exempel
          bokföringsunderlag, kan behållas under den tid lagen kräver.
        </p>

        <div className="mt-8">
          <Link
            to="/kontakt"
            className="inline-flex items-center gap-2 rounded-xl bg-primary px-5 py-3 text-sm font-semibold text-primary-foreground hover:bg-primary/90"
          >
            Begär radering av konto <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
